// Which stream this page is: the main site (125 BPM) or its sister at 72 BPM (slow jams and
// double-time trap), which lives under /72 (`…/72/write`; in the static demo `#/72/write`). The
// stream is fixed for a page load — switching reloads the page into the other site (same account,
// same tapes). API requests of the sister site carry `?bpm=72`.
import { clockFor, type Bpm } from "@eb/shared";
import { DEMO } from "./demo/flag";

function detect(): Bpm {
  if (typeof location === "undefined") return 125;
  const path = DEMO ? location.hash.replace(/^#/, "") : location.pathname;
  return /^\/72(\/|$|\?)/.test(path) ? 72 : 125;
}

export const STREAM_BPM: Bpm = detect();
export const SLOW = STREAM_BPM === 72;
/** Path prefix of this site's routes ("" or "/72"). */
export const PREFIX = SLOW ? "/72" : "";
/** This stream's world clock. */
export const clock = clockFor(STREAM_BPM);
/** The site's name. */
export const SITE_NAME = SLOW ? "The Infinite 72" : "The Infinite";

/** `url` with this stream's `bpm` query parameter (the main stream needs none). */
export function withStream(url: string, bpm: Bpm = STREAM_BPM): string {
  if (bpm === 125 || /[?&]bpm=/.test(url)) return url;
  return `${url}${url.includes("?") ? "&" : "?"}bpm=${bpm}`;
}

/** The href of `route` ("/write") on the site of `bpm` — a full page load when it's the other one. */
export function streamHref(bpm: Bpm, route: string): string {
  const p = bpm === 72 ? `/72${route === "/" ? "" : route}` : route;
  return DEMO ? `${location.pathname}#${p}` : p;
}

/** Go to the other site, on the same page where it makes sense. */
export function switchStream(route: string): void {
  // Song pages, drafts and tapes are per song; the other site starts at its River.
  const keep = /^\/(calendar|write|fame|mixtapes|tapes|u\/|admin|account|about|legal|privacy|terms)/.test(route);
  const to = streamHref(SLOW ? 125 : 72, keep ? route.replace(/^\/write\/.*$/, "/write") : "/");
  if (DEMO) {
    location.hash = to.slice(to.indexOf("#") + 1);
    location.reload();
  } else location.href = to;
}
